<template>
    <el-card >
          <div class="row">
            <div class="col-md-12" v-if="leader" >
                <div style="font-weight: bold;font-size: 20px">
                    LEADER: {{ leader.full_name || leader.name }}
               </div>
               <hr>
               <!-- <el-switch
                    v-model="position"
                    active-text="Members"
                    active-value="member"
                    inactive-value="not_member"
                    inactive-text="Non-members">
                    </el-switch> -->
                    <el-select class="select-default" v-model="position" placeholder="Position" size="small">
                     
                      <el-option class="select-default" label="Members" value="member">
                      </el-option>
                      <el-option class="select-default" label="Non-members" value="not_member">
                      </el-option>
                     
                      <el-option class="select-default" label="Members w/ no Leader" value="member_no_leader">
                      </el-option>
                    </el-select>
               <hr>
            </div>
            <div class="col-md-12" v-if="!leader && barangay" >
                <div style="font-weight: bold;font-size: 20px">
                    Barangay: {{ barangay.name }} ({{ barangay.code }})
               </div>
               <hr>
               <el-switch
                    v-model="position"
                    active-text="Residents"
                    active-value="residents"
                    inactive-value="non_residents"
                    inactive-text="Non-residents">
                    </el-switch>
               <hr>
            </div>
          <div class="col-sm-2">
            <el-select class="" v-model="pagination.perPage" placeholder="Per page">
              <el-option class="select-default" v-for="item in perPageOptions" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </div>
          <div class="col-sm-2">
            <el-checkbox v-model="is_validated" label="Validated" border style="width: 100%;"></el-checkbox>
          </div>
          <div class="col-sm-2">
            <el-checkbox v-model="has_voted" label="Voted" border style="width: 100%;"></el-checkbox>
          </div>
          <div class="col-sm-3">
            <el-checkbox v-model="voted_straight" label="Voted Straight" border ></el-checkbox>
          </div>
          <div class="col-sm-3">
            <div class="pull-right">
              <fg-input class="input-sm" placeholder="Search" v-model="term" addon-right-icon="nc-icon nc-zoom-split">
              </fg-input>
            </div>
          </div>
          <div class="col-sm-12 mt-2" v-loading="loading">
            <el-table class="table-striped" header-row-class-name="text-primary" :data="voters" style="width: 100%">  
              <el-table-column :min-width="120" 
               class-name="td-actions" label="Name">
                <template slot-scope="props">
                  {{ props.row.full_name }}<br>
                  <div>CODE: {{ props.row.code }}</div>
                  <div>COMELEC ID: {{ props.row.comelec_id }}</div>
                  <div>PRECINT NO: {{ props.row.precint_number }}</div>
                  <div v-if="props.row.is_leader" class="text-primary">(LEADER) <span>MEMBERS: {{ props.row.members_count }}</span></div>
                  <div v-if="!props.row.is_leader && props.row.leader" class="text-info">LEAD BY {{ props.row.leader.full_name }}</div>
                </template>
              </el-table-column>

              <el-table-column :min-width="120" 
               class-name="td-actions" label="Address">
                <template slot-scope="props">
                  Purok: {{ props.row.purok }}
                  <div>{{ props.row.full_address }}</div>
                  <div>Birth Date: {{ props.row.birth_date }}</div>
                  <div>Phone: {{ props.row.contact_number }}</div>
                  <div>Email: {{ props.row.email }}</div>
                  <div v-if="props.row.barangay" class="text-primary">{{ props.row.barangay.name }}</div>
                </template>
              </el-table-column>

              <el-table-column :min-width="120" 
               class-name="td-actions" label="Status">
                <template slot-scope="props">
                  <div v-if="props.row.voter_action.is_validated">
                    <el-tag type="success">VALIDATED</el-tag>
                  </div>
                  <div v-if="props.row.voter_action.has_voted">
                    <el-tag type="primary">VOTED</el-tag>
                  </div>
                  <div v-if="props.row.voter_action.voted_straight">
                    <el-tag type="danger">VOTED STRAIGHT</el-tag>
                  </div>
                </template>
              </el-table-column>
              
              <el-table-column :min-width="120" 
               class-name="td-actions" label="Actions">
                <template slot-scope="props">
                  <div v-if="props.row.barangay && props.row.barangay.id == barangay.id && !leader">
                    <div>
                      <el-button type="default" link @click="handleLeader(props.row)" v-if="!props.row.is_leader">
                      Mark as Leader
                    </el-button>
                    </div>
                    <div>
                      <el-button type="default" link @click="handleLeader(props.row, 'mark_as_member')"  v-if="props.row.is_leader">
                      Mark as member
                    </el-button>
                    </div>
                  </div>
                  <div  v-if="leader && leader.id != props.row.id">
                    <el-button type="default" plain @click="handleAdd(props.row)" v-if="(props.row.leader && props.row.leader.id != leader.id) || !props.row.leader">
                      {{ props.row.leader ? 'Transfer':'Add' }}
                    </el-button>
                    <el-button type="danger" plain @click="handleAdd(props.row, 'remove_member')" v-if="props.row.leader && props.row.leader.id == leader.id">Remove</el-button>
                  </div>
                  <div v-if="!leader">
                    <el-button type="default" plain @click="handleAddResident(props.row)" v-if="(props.row.barangay && props.row.barangay.id != barangay.id) || !props.row.barangay">
                        <div v-if="props.row.barangay && props.row.barangay.id != barangay.id ">
                            Transfer from {{ props.row.barangay.name}} <br>
                            to {{ barangay.name}}
                        </div>
                        <div v-else>
                          ADD
                        </div>
                    </el-button>
                    <el-button type="danger" plain @click="handleAddResident(props.row, 'remove_resident')" v-if="props.row.barangay && props.row.barangay.id == barangay.id">Remove</el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="col-sm-6 pagination-info">
            <p class="category">Found {{ pagination.total }} data</p>
          </div>
          <div class="col-sm-6">
            <p-pagination class="pull-right" v-model="pagination.currentPage" :per-page="pagination.perPage"
              :total="pagination.total">
            </p-pagination>
          </div>
          </div>
        </el-card>
  </template>
  <script>
  
  import { Voter } from '@/resources/voter'
  
  export default {
    components: { },
    props: ['barangay', 'leader', 'show_status'],
    data() {
        return {
        loading: false,
        showForm: false,
        voters: [],
        selected: null,
        perPageOptions: [5, 10, 15],
        pagination: {
          perPage: 10,
          currentPage: 1,
          total: 0
        },
        term: null,
        position: 'member',
        is_validated: false,
        has_voted: false,
        voted_straight: false
      }
    },
    watch: {
      term: function () {
        if (!this.term || this.term.length > 2) {
          this.getVoters()
        }
      },
      'pagination.perPage': function () {
        if (this.pagination.currentPage == 1) {
          this.getVoters()
        } else {
          this.pagination.currentPage = 1
        }
      },
      'pagination.currentPage': function () {
        this.getVoters()
      },
      position: function(){
        this.getVoters()
      },
      leader: function(){
        this.getVoters()
      },
      is_validated: function(){
        this.getVoters()
      },
      has_voted: function(){
        this.getVoters()
      },
      voted_straight: function(){
        this.getVoters()
      }
    },
    created: function () {
      this.getVoters()
    },
    methods: {
      handleLeader(model, option){
        this.loading = true
        Voter.update(model.id, {option: option || 'mark_as_leader'})
          .then(result => {
            this.$notify({
              type: 'success',
              title: "Success",
              text: 'Voter has been marked as leader',
            });
            this.getVoters()
          })
          .catch(() => {
  
          }).finally(() => {
            this.loading = false
          })
      },
        handleAddResident(model, option = 'add_resident'){
            this.loading = true
        Voter.update(model.id, {option: option, barangay_id: this.barangay.id })
          .then(result => {
            this.$notify({
              type: 'success',
              title: "Success",
              text: 'Voter has been assigned to the barangay',
            });
            this.getVoters()
          })
          .catch(() => {
  
          }).finally(() => {
            this.loading = false
          })
        },
        handleAdd(model, option = 'add_as_member'){
            this.loading = true
        Voter.update(model.id, {option: option, leader_id: this.leader.id, })
          .then(result => {
            this.$notify({
              type: 'success',
              title: "Success",
              text: 'Voter has been assigned to a leader',
            });
            this.getVoters()
          })
          .catch(() => {
  
          }).finally(() => {
            this.loading = false
          })
        },
      getVoters() {
        let params = { 
          term: this.term, 
          position: this.position, 
          page: this.pagination.currentPage, 
          per_page: this.pagination.perPage, 
          barangay_id: this.barangay.id,
          is_validated: this.is_validated,
          has_voted: this.has_voted,
          voted_straight: this.voted_straight
        }
        if (this.leader) {
          params.leader_id = this.leader.leader_id || this.leader.id
        }
        this.loading = true
        Voter.get(params)
          .then(result => {
            this.pagination = result.data.meta
            if (result.data.voters)
              this.voters = result.data.voters
          })
          .catch(() => {
            this.$notify({
              type: 'danger',
              title: "Error",
              text: 'Unable to fetch voters',
            });
  
          }).finally(() => {
            this.loading = false
          })
      },
    }
  }
  </script>
  <style lang="scss"></style>
  